export default __webpack_public_path__ + "./images/ie.21c9f323.png";